<template>
  <label><slot></slot></label>
</template>

<script>
export default {

}
</script>

<style>

</style>